export type Environment = "dev" | "uat" | "preview" | "prod";

const allowedHostnames: Record<string, Environment> = {
  localhost: "dev",
  "127.0.0.1": "dev",
  "dev.modernadirect.com": "dev",
  "uat.modernadirect.com": "uat",
  "preview.modernadirect.com": "preview",
  "modernadirect.com": "prod"
};

export const getEnvironment = (): Environment =>
  allowedHostnames[window.location.hostname] || "dev";
